import { useCallback, useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
import { modulesApi } from '../api/modules.api';
export const useModules = (searchNow = false) => {
  const [modulesNames, setModulesNames] = useState([]);
  const getNamesModules = useCallback(async () => {
    try {
      const response = await modulesApi.getNames();
      setModulesNames(response);
      return response;
    } catch (error) {
      toast.error(error || error.message || TOAST_ERROR_IDS.ERROR_OBTAINING_NAMES + 'módulos');
    }
  }, []);
  useEffect(() => {
    if (searchNow) getNamesModules();
  }, [searchNow]);
  return { getNamesModules, modulesNames };
};
